<template>
  <span v-if="params.customData" class="text-link-blue fake-link" @click.prevent="onClick(params.customData.id)">
    {{ params.customData.label }}
  </span>
</template>

<script>
import Vue from 'vue'
import router from '@router'
import store from '@store'

export default Vue.extend({
  name: 'ModalLinkTrigger',
  router,
  store,
  methods: {
    onClick(params) {
      this.params.customData.onClick(params)
    }
  }
})
</script>
